import { styled } from 'styled-components';
import { colors } from '../../../abstracts/colors';
import { createTransition, dontForwardProps } from '../../../util';
const getBeforeToggleBoxShadow = ({
  checked,
  disabled,
  theme,
  isFocused,
  hoverState
}) => {
  if (isFocused) {
    return `0 0 0 2px ${theme.secondaryPressed} inset`;
  } else if (hoverState === 'active' && !disabled) {
    if (checked) {
      return `0 0 0 2px ${theme.secondaryPressed} inset`;
    }
    return `0 0 0 2px ${colors.black} inset`;
  } else if (hoverState === 'hover' && !disabled) {
    if (checked) {
      return `0 0 0 2px ${theme.secondaryHover} inset`;
    }
    return `0 0 0 1px ${colors.black} inset`;
  } else if (disabled && !checked) {
    return `0 0 0 1px ${colors.neutralDeep} inset;`;
  } else if (checked) {
    return `0 0 0 2px ${theme.secondary} inset;`;
  }
  return `0 0 0 1px ${colors.neutralDeeper} inset;`;
};
const getAfterToggleBackgroundColor = ({
  checked,
  theme,
  isFocused,
  hoverState,
  disabled
}) => {
  if (hoverState === 'active' && !disabled) {
    if (checked) {
      return theme.secondary;
    }
    return colors.neutralBrightest;
  } else if (hoverState === 'hover' && !disabled) {
    if (checked) {
      return theme.secondaryHover;
    }
    return colors.neutralBrightest;
  } else if (checked || isFocused) {
    return theme.secondary;
  }
  return '';
};
const getBeforeToggleBackgroundColor = ({
  checked,
  disabled,
  isFocused
}) => {
  if (isFocused && checked && !disabled) {
    return colors.neutralBrightest;
  }
  if (disabled) {
    return colors.disabledBackground;
  }
  return colors.white;
};
export const RadioToggle = styled.span.withConfig(dontForwardProps()).withConfig({
  displayName: "RadioToggle",
  componentId: "asurion-ui-react__sc-1valdbw-0"
})(["position:relative;cursor:", ";display:block;", " &::before,&::after{content:'';display:block;", "}&::before{height:20px;width:20px;border-radius:100%;opacity:1;margin:0 0.5rem 0 0;background-color:", ";box-shadow:", ";}&::after{position:absolute;top:5px;left:5px;height:10px;width:10px;border-radius:50%;opacity:", ";background-color:", ";", "}"], ({
  disabled
}) => disabled ? 'not-allowed' : 'pointer', ({
  checked,
  disabled
}) => checked && disabled && 'opacity: 0.4;', () => createTransition({
  properties: ['box-shadow', 'background-color', 'border-color']
}), getBeforeToggleBackgroundColor, getBeforeToggleBoxShadow, ({
  checked,
  disabled,
  hoverState
}) => checked || hoverState === 'active' && !disabled ? 1 : 0, getAfterToggleBackgroundColor, ({
  disabled
}) => disabled && 'box-shadow: none;');